module.exports = __webpack_public_path__ + "static/media/12.ee176562.jpg";